module.exports = __webpack_public_path__ + "assets/img/form_icon.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/form_icon.png
// module id = 695
// module chunks = 0